<template>
    <div v-if="table.id">
        <!-- Render a custom view -->
        <div v-if="document && view.layout && view.layout.rows">
            <div v-for="(row, index) in view.layout.rows">
                <row-renderer :layout="view.layout" :row="row" :index="index" :key="index + view.id + 'row'"
                              :document="document" :table="table" :view="view"></row-renderer>
            </div>
        </div>

        <!-- Render a static default view -->
        <show-view v-else :table_id="table.id" :record_id="recordId"></show-view>
    </div>
</template>

<script>

    import ShowView from "../ShowView.vue";

    export default {
        name: 'DetailsRenderer',
        components: {ShowView},
        props: {
            view: Object,
            table: Object,
            document: Object,
            recordId: String
        },
        data() {
            return {
                model: webase.model,
                // viewService: new ViewService(),
                // modelService: new ModelService()
            }
        },
        mounted() {
            window.scrollTo(0, 0)
            // let viewId = this.$route.params.view_id
            // this.recordId = this.$route.params.record_id
            //
            // this.viewService.get(viewId).then((response) => {
            //     this.view = response
            //     let app = response.app
            //     console.log('Details initi app')
            //     webase.utils.app.initAppProperties(app)
            //     this.model.app = app
            //     this.table = webase.utils.array.get(this.model.app.tables, this.view.model_id)
            //
            //     this.loadData()
            // }).catch((message) => {
            //     console.log('error loading view')
            //     console.log(message)
            // })
        },
        methods: {
            // loadData() {
            //
            //     this.modelService.getDocument(this.table, this.recordId).then((response) => {
            //         this.document = response
            //     }).catch((message) => {
            //         console.log('error loading records from table')
            //         console.log(message)
            //     })
            // },
        }
    }
</script>

<style>

</style>
